import React, { useState } from 'react';
import './Emailtmp.css';

const EmailTemplateMaster = () => {
    const [selectedTemplate, setSelectedTemplate] = useState('template1');
    const [templateData, setTemplateData] = useState({
        header: {
            logo: 'https://via.placeholder.com/150x50',
            logoUrl: 'https://via.placeholder.com/150x50',
            title: 'Your Company Name',
            backgroundColor: '#4F46E5',
            textColor: '#FFFFFF'
        },
        body: {
            title: 'Welcome to Our Service!',
            content: 'This is the main content of your email template. You can customize this section with your message.',
            backgroundColor: '#FFFFFF',
            textColor: '#333333'
        },
        footer: {
            text: '© 2024 Your Company. All rights reserved.',
            links: [
                { text: 'Privacy Policy', url: '#' },
                { text: 'Unsubscribe', url: '#' }
            ],
            backgroundColor: '#F3F4F6',
            textColor: '#6B7280'
        }
    });

    const templates = [
        { id: 'template1', name: 'Modern Business', preview: '🎨' },
        { id: 'template2', name: 'Clean Newsletter', preview: '📰' },
        { id: 'template3', name: 'Promotional', preview: '🔥' },
        { id: 'template4', name: 'Minimalist', preview: '✨' }
    ];

    const handleTemplateSelect = (templateId) => {
        setSelectedTemplate(templateId);
        // Load template preset data
        const templatePresets = {
            template1: {
                header: { ...templateData.header, backgroundColor: '#4F46E5' },
                body: { ...templateData.body },
                footer: { ...templateData.footer, backgroundColor: '#F3F4F6' }
            },
            template2: {
                header: { ...templateData.header, backgroundColor: '#10B981' },
                body: { ...templateData.body },
                footer: { ...templateData.footer, backgroundColor: '#D1FAE5' }
            },
            template3: {
                header: { ...templateData.header, backgroundColor: '#F59E0B' },
                body: { ...templateData.body },
                footer: { ...templateData.footer, backgroundColor: '#FEF3C7' }
            },
            template4: {
                header: { ...templateData.header, backgroundColor: '#6B7280' },
                body: { ...templateData.body },
                footer: { ...templateData.footer, backgroundColor: '#E5E7EB' }
            }
        };
        setTemplateData(templatePresets[templateId]);
    };

    const handleInputChange = (section, field, value) => {
        setTemplateData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                handleInputChange('header', 'logo', event.target.result);
                handleInputChange('header', 'logoUrl', event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAddFooterLink = () => {
        const newLinks = [...templateData.footer.links, { text: 'New Link', url: '#' }];
        setTemplateData(prev => ({
            ...prev,
            footer: { ...prev.footer, links: newLinks }
        }));
    };

    const handleFooterLinkChange = (index, field, value) => {
        const newLinks = [...templateData.footer.links];
        newLinks[index][field] = value;
        setTemplateData(prev => ({
            ...prev,
            footer: { ...prev.footer, links: newLinks }
        }));
    };

    const handleRemoveFooterLink = (index) => {
        const newLinks = templateData.footer.links.filter((_, i) => i !== index);
        setTemplateData(prev => ({
            ...prev,
            footer: { ...prev.footer, links: newLinks }
        }));
    };

    return (
        <div className="email-template-master">
            <div className="template-container">
                <div className="template-sidebar">
                    <h3>Select Template</h3>
                    <div className="template-list">
                        {templates.map(template => (
                            <div
                                key={template.id}
                                className={`template-item ${selectedTemplate === template.id ? 'selected' : ''}`}
                                onClick={() => handleTemplateSelect(template.id)}
                            >
                                <span className="template-preview">{template.preview}</span>
                                <span className="template-name">{template.name}</span>
                                {selectedTemplate === template.id && (
                                    <span className="selected-indicator">✓</span>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Controls Section */}
                    <div className="controls-section">
                        <h3>Template Controls</h3>
                        <button className="btn-save">Save Template</button>
                        <button className="btn-reset" onClick={() => handleTemplateSelect(selectedTemplate)}>
                            Reset to Default
                        </button>
                        <button className="btn-export">Export HTML</button>
                    </div>
                </div>

                {/* Preview Panel */}
                <div className="preview-panel">
                    <h3>Preview</h3>
                    <div className="email-preview">
                        {/* Header */}
                        <div
                            className="email-header"
                            style={{
                                backgroundColor: templateData.header.backgroundColor,
                                color: templateData.header.textColor
                            }}
                        >
                            <div className="header-content">
                                <img
                                    src={templateData.header.logo}
                                    alt="Logo"
                                    className="header-logo"
                                />
                                <h2 className="header-title">{templateData.header.title}</h2>
                            </div>
                        </div>

                        {/* Body */}
                        <div
                            className="email-body"
                            style={{
                                backgroundColor: templateData.body.backgroundColor,
                                color: templateData.body.textColor
                            }}
                        >
                            <h3 className="body-title">{templateData.body.title}</h3>
                            <div className="body-content">
                                {templateData.body.content}
                            </div>
                        </div>

                        {/* Footer */}
                        <div
                            className="email-footer"
                            style={{
                                backgroundColor: templateData.footer.backgroundColor,
                                color: templateData.footer.textColor
                            }}
                        >
                            <p className="footer-text">{templateData.footer.text}</p>
                            <div className="footer-links">
                                {templateData.footer.links.map((link, index) => (
                                    <a
                                        key={index}
                                        href={link.url}
                                        style={{ color: templateData.footer.textColor }}
                                    >
                                        {link.text}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Configuration Panel */}
                <div className="config-panel">
                    <h3>Customize Template</h3>

                    {/* Header Configuration */}
                    <div className="config-section">
                        <h4>Header Settings</h4>
                        <div className="form-group">
                            <label>Logo:</label>
                            <input type="file" accept="image/*" onChange={handleLogoUpload} />
                        </div>
                        <div className="form-group">
                            <label>Logo URL:</label>
                            <input
                                type="text"
                                value={templateData.header.logoUrl}
                                onChange={(e) => handleInputChange('header', 'logoUrl', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Title:</label>
                            <input
                                type="text"
                                value={templateData.header.title}
                                onChange={(e) => handleInputChange('header', 'title', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Background Color:</label>
                            <input
                                type="color"
                                value={templateData.header.backgroundColor}
                                onChange={(e) => handleInputChange('header', 'backgroundColor', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Text Color:</label>
                            <input
                                type="color"
                                value={templateData.header.textColor}
                                onChange={(e) => handleInputChange('header', 'textColor', e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Body Configuration */}
                    <div className="config-section">
                        <h4>Body Settings</h4>
                        <div className="form-group">
                            <label>Title:</label>
                            <input
                                type="text"
                                value={templateData.body.title}
                                onChange={(e) => handleInputChange('body', 'title', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Content:</label>
                            <textarea
                                value={templateData.body.content}
                                onChange={(e) => handleInputChange('body', 'content', e.target.value)}
                                rows="4"
                            />
                        </div>
                        <div className="form-group">
                            <label>Background Color:</label>
                            <input
                                type="color"
                                value={templateData.body.backgroundColor}
                                onChange={(e) => handleInputChange('body', 'backgroundColor', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Text Color:</label>
                            <input
                                type="color"
                                value={templateData.body.textColor}
                                onChange={(e) => handleInputChange('body', 'textColor', e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Footer Configuration */}
                    <div className="config-section">
                        <h4>Footer Settings</h4>
                        <div className="form-group">
                            <label>Footer Text:</label>
                            <input
                                type="text"
                                value={templateData.footer.text}
                                onChange={(e) => handleInputChange('footer', 'text', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Background Color:</label>
                            <input
                                type="color"
                                value={templateData.footer.backgroundColor}
                                onChange={(e) => handleInputChange('footer', 'backgroundColor', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Text Color:</label>
                            <input
                                type="color"
                                value={templateData.footer.textColor}
                                onChange={(e) => handleInputChange('footer', 'textColor', e.target.value)}
                            />
                        </div>

                        <div className="footer-links-section">
                            <label>Footer Links:</label>
                            {templateData.footer.links.map((link, index) => (
                                <div key={index} className="footer-link-item">
                                    <input
                                        type="text"
                                        placeholder="Link Text"
                                        value={link.text}
                                        onChange={(e) => handleFooterLinkChange(index, 'text', e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        placeholder="URL"
                                        value={link.url}
                                        onChange={(e) => handleFooterLinkChange(index, 'url', e.target.value)}
                                    />
                                    <button
                                        className="btn-remove"
                                        onClick={() => handleRemoveFooterLink(index)}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                            <button className="btn-add-link" onClick={handleAddFooterLink}>
                                + Add Link
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailTemplateMaster;